import { useCallback } from "react";
import { useLoading } from "@context/LoadingContext";

interface UseGlobalLoaderReturn {
  showLoader: (text?: string) => void;
  hideLoader: () => void;
  setLoadingText: (text: string) => void;
  withLoader: <T extends any[], R>(
    asyncFunction: (...args: T) => Promise<R>,
    loadingText?: string
  ) => (...args: T) => Promise<R>;
}

export const useGlobalLoader = (): UseGlobalLoaderReturn => {
  const { showLoader, hideLoader, setLoadingText } = useLoading();

  const withLoader = useCallback(
    <T extends any[], R>(
      asyncFunction: (...args: T) => Promise<R>,
      loadingText?: string
    ) => {
      return async (...args: T): Promise<R> => {
        try {
          showLoader(loadingText);
          const result = await asyncFunction(...args);
          return result;
        } finally {
          hideLoader();
        }
      };
    },
    [showLoader, hideLoader]
  );

  return {
    showLoader,
    hideLoader,
    setLoadingText,
    withLoader,
  };
}; 